/**
 * Minimal CSV export (tv-9jh). A pure `toCsv` (header + rows → RFC-4180-ish
 * string) plus a client-side `downloadCsv` (blob + anchor, no server). The
 * export format is a sensible default the client can re-tune.
 */
export function toCsv(headers: string[], rows: (string | number)[][]): string {
  const esc = (v: string | number): string => {
    const s = String(v);
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  return [headers, ...rows].map((row) => row.map(esc).join(',')).join('\n');
}

/** Trigger a client-side CSV download. No-op when the DOM APIs are unavailable. */
export function downloadCsv(filename: string, csv: string): void {
  try {
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  } catch {
    // Download unavailable (e.g. a sandboxed/test environment) — no-op.
  }
}
